export type TreeScaleProfileId =
  | 'TREE_SCALE_1K'
  | 'TREE_SCALE_10K'
  | 'TREE_SCALE_100K'
  | 'TREE_SCALE_1M';

export type TreeScaleSimulationProfile = {
  id: TreeScaleProfileId;
  label: string;
  targetUserCount: number;
  measuredSampleSize: number;
  projectionRequired: boolean;
  mode: 'SIMULATED';
  liveCertified: false;
  productionWritesAllowed: false;
  purpose: string;
};

export const TREE_SCALE_SIMULATION_PROFILES:
  TreeScaleSimulationProfile[] = [
    {
      id: 'TREE_SCALE_1K',
      label: '1,000-user Tree workload',
      targetUserCount: 1_000,
      measuredSampleSize: 1_000,
      projectionRequired: false,
      mode: 'SIMULATED',
      liveCertified: false,
      productionWritesAllowed: false,
      purpose:
        'Measure deterministic relationship, scan, and projection costs for a large family graph.',
    },
    {
      id: 'TREE_SCALE_10K',
      label: '10,000-user Tree workload',
      targetUserCount: 10_000,
      measuredSampleSize: 10_000,
      projectionRequired: false,
      mode: 'SIMULATED',
      liveCertified: false,
      productionWritesAllowed: false,
      purpose:
        'Measure bounded browser and engine behavior under an extreme single-graph workload.',
    },
    {
      id: 'TREE_SCALE_100K',
      label: '100,000-user Tree capacity projection',
      targetUserCount: 100_000,
      measuredSampleSize: 10_000,
      projectionRequired: true,
      mode: 'SIMULATED',
      liveCertified: false,
      productionWritesAllowed: false,
      purpose:
        'Project service-wide Tree workload from measured bounded samples without allocating 100,000 browser nodes.',
    },
    {
      id: 'TREE_SCALE_1M',
      label: '1,000,000-user Tree capacity projection',
      targetUserCount: 1_000_000,
      measuredSampleSize: 10_000,
      projectionRequired: true,
      mode: 'SIMULATED',
      liveCertified: false,
      productionWritesAllowed: false,
      purpose:
        'Model million-user service capacity while keeping memory, execution time, and production data isolated.',
    },
  ];
